export default {

  login: {
    welcomeMsg: "¡Bienvenido! Inicie la sesión",
    info: "Ingrese sus credenciales",
    forgot: "¿Ha olvidado la contraseña?",
    btn: "Iniciar sesión",
    unableToLogin: "No es posible iniciar la sesión",
  },
  forgot: {
    info_l1:
      "Ingrese el correo electrónico asociado a su cuenta. Se enviarán los detalles de la contraseña a su correo electrónico.",
    info_l2:
      "Ingrese su número de móvil asociado con la cuenta. Se enviarán los detalles de su contraseña a su móvil.",
    forgotQ: "¿Ha olvidado su contraseña?",
    loginNow: "Iniciar sesión ahora",
    resetSucc: "Se ha restablecido su contraseña correctamente.",
    resetSucc_l2:
      "Ahora usted puede utilizar su nueva contraseña para iniciar su sesión de su cuenta.",
    entPsw: "Ingrese su nueva contraseña.",
    resetPsw: "Restablecer su contraseña",
    resendOTP: "Reenviar OTP",
    enterCorrectOTP: "Ingrese OTP correcto.",
    enterOTP: "Ingrese OTP recibido en su correo electrónico/ móvil.",
    backToLoginPage: "Volver a la página de inicio de sesión",

    changePassword: "Cambiar contraseña",
    "changePasswordSubtitle": "Por favor, introduce tu nueva contraseña a continuación",
    "oldPassword": "Contraseña anterior",
    "newPassword": "Nueva contraseña",
    "confirmPassword": "Confirmar contraseña",
    "resetPassword": "Restablecer contraseña",
    "resetPasswordSubtitle": "Por favor, introduce tu nueva contraseña a continuación",
    "resetPasswordBtn": "Restablecer contraseña",
    "backToLogin": "Volver al inicio de sesión",
    "oldPasswordRequired": "Se requiere la contraseña anterior",
    "passwordResetSuccess": "Contraseña restablecida con éxito",
    "passwordResetFailed": "Error al restablecer la contraseña",
    "errorOccurred": "Ocurrió un error"
  },
    buySell: {
    farmerName: "Nombre del agricultor",
    location:   "Ubicación",
    country:  "País",
    gender: "Sexo",
    noOfOrdersSold: "Cantidad de pedidos vendidos",  
    noOfPurchaseOrders:   "Cantidad de pedidos de compra",
    totalPurchaseSaleVolume:    "Volumen total de compra/venta",
    totalAvgValue:    "Valor promedio total", 
    searchOrderByID:   "Buscar pedido por ID",
    totalNumberofOrders:   "Cantidad total de pedidos",
    totalNumberOfTransactions:   "Cantidad total de transacciones",
    totalWeightOfTransactions:   "Peso total de las transacciones",
    totalMonetaryValue:   "Valor monetario total",
    averagePriceperKg:   "Precio promedio por kg",
    sellingAvgValuePerKg: "Valor promedio de venta por Kg",
    purchaseAvgValuePerKg: "Valor promedio de compra por Kg",
    },
  userslist: {
    createNewUser: "Crear un Nuevo Usuario",
    chooseCreateType: "Por favor, elija una de las siguientes opciones:",
    addNewUser: "Agregar Nuevo Usuario",
    editUser: "Editar Usuario",
    addNewAdmin: "Agregar Usuario Administrador",
    userLoading: "Cargando Usuarios... Por favor, espere",
    noUser: "NO HAY USUARIO DISPONIBLE",
    extendVal: "EXTENDER VALIDEZ",
    extendReason: "Motivo de la Extensión",
    extendReasonMsg: "Especifique el motivo de la extensión de la membresía",
    exportAsCSV: "EXPORTAR COMO CSV",
    membershipType: "Tipo de Membresía",
    membershipValidity: "Validez de la Membresía",
    regionState: "Región/Estado",
    cityTown: "Ciudad/Pueblo",
    clearAll: "BORRAR TODO",
    search: "BUSCAR",
    familyTribe: "Ingrese su tribu familiar",
    enterWebsite: "Ingrese al sitio web",
    registrationDate: "Fecha de Registro",
    single: "Soltero",
    multiple: "Múltiple",
    user: "Usuario",
    users: "Usuarios",
    role: "Rol",
    department: "Departamento",
  },
  addEdituser: {
    firstNameRequired: "Se requiere primero nombre",
    firstNameOllyAlpha: "El primero nombre solo puede contener letras",
    firstNameLimit: "El primero nombre debe tener menos de 50 caracteres",
    lastNameRequired: "Se requiere Apellido",
    lastNameOllyAlpha: "El Apellido solo puede contener letras",
    lastNameLimit: "El Apellido debe tener menos de 50 caracteres",
    emailReuired: "Se requiere el correo electrónico",
    emailInvalid: "Formato inválido de correo electrónico.",
    mobileRequired: "Se requiere el número de móvil",
    mobileLimit: "El número de móvil debe tener menos de 15 dígitos",
    invalidMobile: "Formato de número de móvil inválido.",
    emailExistAlready: "El usuario ya existe con este correo electrónico.",
    mobileExistAlready: "El usuario ya existe con este número de móvil.",
    pswRequired: "Se requiere la contraseña",
    deptRequired: "Se requiere el departamento",
    roleRequired: "Se requiere la función",
    countryRequired: "Se requiere el código del país",
    userUpdated: "Usuario actualizado",
    userNotUpdated: "Usuario no actualizado",
    activateAct: "Activar cuenta",
    deactivateAct: "Desactivar cuenta",
    areYouSureYouWantToDeactivateThisFarmer: "¿Está seguro de que desea desactivar este agricultor?",
    userActivated: "Usuario activado",
    userDeactivated: "Usuario desactivado",
    deactivateUser: "Desactivar usuario",
    deactivateMsg: "¿Seguro que desea cambiar estado de usuario?",
    userAdded: "Usuario añadido",
    userNotAdded: "Usuario no añadido",
    facilityPicture: "Facility Picture",
    editAppUser: "Editar usuario de la aplicación",
    validityUpTo: "Válido Hasta",
    roleEdited: "Rol Editado",
    addDepartment: "Agregar Departamento",
    editDepartment: "Editar Departamento",
    department: "Departamento",
    noDepartment: "Sin Departamento",
    departmentNameRequired: "El nombre del departamento es obligatorio",
    departmentAdded: "Departamento Agregado",
    departmentEdited: "Departamento Editado",
    eoriNumberRequired: "Número EORI obligatorio",
    eoriIsNumber: "EORI debe ser un número",
    addNewSupplier: "Agregar Nuevo Proveedor",
    addNewProducer: "Agregar Nuevo Productor",
    addNewOperator: "Agregar Nuevo Operador",
    eoriNumber: "Número EORI",
  },
  permissions: {
    savePermissions: "Guardar permisos",
    moduleName: "Nombre del módulo",
    view: "Vista",
    create: "Crear",
    update: "Actualizar",
    delete: "Borrar",
    permissionsUpdated: "Permisos actualizados",
    permissionsNotUpdated: "Permisos no actualizados",
    selectMembership: "Seleccionar membresía",
    noPermMsg:
      "Seleccione el tipo de membresía usando el menú desplegable 'Tipo de membresía' arriba para ver sus permisos",
    selectRoleMsg: "Seleccione la función de arriba para enseñar los permisos",
  },

  profileSetting: {
    profileAuthSettings: "Configuración de autenticación de perfil",
    changeSettings: "Configuraciones de cambios",
    loginLogoutSettings: "Configuración de inicio de sesión/ cierre de sesión",
    autoLogout: "Cierre automático de sesión",
    unsuccAtmp: "Intentos de inicio de sesión sin éxito",
    unsuccLoginLock: "Periodo de bloqueo de inicio de sesión sin éxito",
    pswCrisetup: "Configuraciones de los parámetros de la contraseña",
    pswLength: "Longitud de contraseña",
    noOfUniquePsw: "Número de contraseñas únicas requeridas",
    maxPswAge: "Edad máxima de la contraseña",
    AccRangeOfchars: "Rango aceptable de caracteres",
    upperCase: "Mayúscula",
    lowerCase: "Minúscula",
    numbers: "números",
    specialChars: "Caracteres especiales",
    settingsUpdated: "Configuraciones actualizadas",
    settingsNotUpdated: "Configuraciones no actualizadas",
    organization: "Organization",
    organizationLogo: "Organization Logo",
    organizationSplash: "Pantalla de presentación de la organización",
    alertCrop: "Cultivo",
    alertCropInfo: "Cultivo para el cual recibirás alertas",
    alertCountry: "País",
    alertCountryInfo: "País para el cual recibirás alertas",
    alertRegion: "Región",
    alertRegionInfo:
      "Región del país seleccionado para la cual recibirás alertas",
    alertMaximum: "Cantidad máxima",
    alertMaximumInfo:
      "Cantidad máxima permitida después de la cual recibirás alertas",
    selectCrop: "Seleccionar Cultivo",
    alertFor: "Seleccionar quién recibirá la alerta",
    alertAdmin: "Alerta para el administrador",
    alertFarmer: "Alerta para el Agricultor",
    cropsHarvestAlert: "Alertas de cosecha de cultivos",
    selectCountry: "Seleccionar País",
    selectCountryInfo: "Elija la ubicación geográfica aplicable a la evaluación.",
    maxAllowed: "Máximo permitido / Ha / Yr",
    maxProduction: "Máxima producción / Hectáreas / Año",
    crop: "Cultivos",
    alert: "Alerta",
    selectCountryError: "Seleccione primero el país",
    unitError: "Establezca la producción máxima y la unidad",
  },

  adminRoles: {
    adminRoles: "Funciones de administrador",
    roleName: "Nombre de la función",
    description: "Descripción",
    viewPermissions: "Visualizar permisos",
    createAdminRole: "CREAR FUNCIÓN DE ADMINISTRADOR",
    enterDesHere: "Ingresar su descripción aquí",
    deleteRole: "Eliminar puesto",
    deleteMsg: "¿Seguro que desea eliminar el puesto de supervisor?",
    roleReq: "Se requiere el nombre de la función",
    roleLimit: "El nombre de la función debe tener menos de 15 caracteres",
    desReq: "Se requiere la descripción",
    desLimit: "La descripción debe tener 40 caracteres o menos",
    roleSuccess: "Se ha creado la función correctamente",
    editAdminRole: "Editar función admin",
    roleUpdated: "usuario actualizado",
    noRole: "No se ha encontrado ninguna función de admin",
    noRoleMsg:
      "Cree la función admin utilizando el botón ' Crear Función Admin' de arriba",
    roleType: "Tipo de función",
  },
  membershipplanSection: {
    defaultPlan: "Plan por defecto",
    planDuration: "Duración del plan",
    planFee: "Tasa del plan",
    satelliteReport: "Informes por satélite",
    advanceReport: "INFORME AVANZADO",
    addMembership: "Añadir membresía",
    addMembershipPlan: "Añadir plan de membresía",
    accessSetelite:
      "Acceso a los informes por satélite (conjunto de 5 informes)",
    accessAdvanceReport: "Acceso a los informes avanzados",
    memPlanReq: "Se requiere el plan de membresía",
    memPlanReqLimit: "El plan de membresía debe tener menos de 20 caracteres",
    SatelliteReq: "Se requiere el informe por satélite",
    advancedReportReq: "Se requiere el informe avanzado",
    durationReq: "Se requiere la duración de la membresía",
    feeReq: "Se requiere la tarifa de membresía",
    cantLesThenZero: "No puede ser menos de 0",
    roleReq: "Se requiere la función del usuario",
    selectPlan: "Seleccionar Plan",
    planType: "Tipo de Plan",
    enterprise: "Empresa",
    noOfUsersAllowed: "Número de usuarios permitidos",
    noOfFarms: "Número de fincas",
    perUser: "Por Usuario",
    perFarm: "Por Finca",
    accessToDeforestationReport:
      "Acceso a Informes de Deforestación (Por Usuario)",
    satelliteReportPackage: "Paquete de Informes por Satélite",
    basicFarmLevelReports: "Informes Básicos a Nivel de Finca",
    advancedFarmLevelReports: "Informes Avanzados a Nivel de Finca",
    largeAreaReports: "Informes de Áreas Extensas",
  },
 
  roleRequest: {
    roleRequest: "Solicitud de función",
    userRole: "Puesto del usuario",
    approve: "Aprobado",
    reject: "Rechazado",
    username: "Nombre de usuario",
    email: "Correo eletrónico",
    phone: "Teléfono",
    roleAssigned: "Puesto asignado",
    roleRequested: "Puesto solicitado",
    requestedDate: "Fecha solicitada",
    updateRoleRequest: "Actualizar Solicitud de función",
    message: "mensaje",
    update: "Actualizar",
  },

  membership: {
    remainingDays: "Número de días restantes",
    type: "Tipo de membresía",
    validity: "Validez de la membresía",
    validityLength: {
      custom: "Personalizado",
      expired: "Expirado",
      oneTo8Months: "1-8 meses",
      lessThan1Month: "Menos de 1 mes",
      moreThan1Month: "Más de 1 año",
      sixTo12Months: "6-12 meses",
    },
  },

  statusItems: {
    closed: "Cerrado",
    open: "Abierto",
  },
  orderByItems: {
    all: "Todos",
    dateAscending: "Fecha ascendente",
    dateDescending: "Fecha descendente",
    dueDate: "Fecha límite",
    high: "Alto",
    low: "Bajo",
    medium: "Medio",
  },

  ownershipTypes: {
    EXW: "EXW (En Fábrica)",
    FCA: "FCA (Libre Transportista)",
    CPT: "CPT (Transporte Pagado Hasta)",
    CIP: "CIP (Transporte y Seguro Pagados Hasta)",
    DAP: "DAP (Entregado en el Lugar)",
    DPU: "DPU (Entregado en el Lugar Descargado)",
    DDP: "DDP (Entregado con Derechos Pagados)",
    FAS: "FAS (Libre al Costado del Buque)",
    FOB: "FOB (Libre a Bordo)",
    CFR: "CFR (Costo y Flete)",
    CIF: "CIF (Costo, Seguro y Flete)"
  },


  activationKey: {
    enterActivationKey: "Please enter activation key to register a new user",
    activationKeyRequired: "Clave de activación requerida",
    activationKeyLimit: "Minimum 15 characters",
    countryRequired: "Country Code is required",
    activationKey: "Teclas de activación",
    appointSalesManager: "Designar gerente de ventas",
    appointManager: "DESIGNAR GERENTE",
    salesManAppSuccess: "GERENTE DE VENTAS DESIGNADO CORRECTAMENTE",
    uploadData: "UPLOAD ASSIGNEDESIGNAR GERENTED DATA CSV",
    uploadUserData: "Cargue el archivo de datos del usuario",
    downloadCsv:
      "(Descargar la muestra archivo .csv para seguir la estructura)",
    downloadSample: "Descargar archivo muestra",
    dragDrop: "Arrastrar y soltar o navegar en su archivo ",
    browse: "explorar",
    yourFile: "su archivo",
    pdfSupport: "Solo se admiten archivos PDF.",
    pleaseWait: "Por favor espera",
    note: "Nota",
    incorectFileType: "Tipo incorrecto de archivo",
    somethingWentWrong: "Algo salió mal. Inténtalo de nuevo más tarde. ",
    fileUploadedSuccess: "Se ha cargado el archivo correctamente",
    countRecords: "Contar registros",
    sendNow: "ENVIAR AHORA",
    fileName: "Nombre del archivo",
    assignActKey: "Designar teclas de activación",
    actKeyAssSucc: "Se ha asignado las teclas de activación correctamente",
    viewActKey: "VISUALIZAR TECLAS DE ACTIVACIÓN",
    actKeyQuota: "Cuota de teclas de activación",
    genActKey: "Teclas de activación generadas",
    remActKey: "Teclas de activación restantes",
    penUsed: "Teclas pendientes y utilizadas",
    activationKeyAss: "Teclas de activación asignadas",
    activationKeyUnass: "Teclas de activación no asignadas",
    keysAct: "Teclas activadas",
    uploadedFiles: "Archivos cargados",
    generateActKey: "GENERAR TECLAS DE ACTIVACIÓN",
    showData: "Mostrar datos",
    noDataFound: "No se ha encontrado ninguna fecha",
    pleaseGenKey:
      'Genere las teclas de activación utilizando "Generar las teclas de activación"',
    noActKey: "No se ha generado ninguna tecla de activación",
    buttonAbv: "botón de arriba",
    numberOfActKey: "Número de teclas de activación",
    membershipRole: "Función de membresía",
    membershipPlan: "Planes de Membresía",
    comments: "Comentarios",
    genKeys: "GENERAR TECLAS",
    keysNum: "Número de teclas",
    phoneNumber: "Número de teléfono",
    keysStatus: "Situación de las teclas",
    ActivationKeysList: "Lista de teclas de activación",
    back: "VOLVER",
    usingActKeys:
      'Genere las teclas de activación utilizando "Generar las teclas de activación""',
    pleaseGenActKeyss: "Genere las teclas de activación",
    clearAllFilters: "ELIMINAR TODOS LOS FILTROS",
    salesManager: "Gerente de ventas",
    clearAll: "ELIMINAR TODO",
    generatedBy: "Generado por",
    numberOfKeys: "Número de teclas",
    action: "Acción",
    viewAllUplFiles: "Visualizar todos los archivos cargados",
    bulkUploadUsers: "Cargar mayor parte de los usuarios",
    noActivationKeyFound: "No se encontrado teclas de activación",
    pleaseCreateAdminRole: "Cree la función admin utilizando el",
    btnCreateAdmin: 'botón "Crear función admin" de arriba',
    donwloadAsCsv: "Descargar como CSV",
    donwloadAsPdf: "Descargar como PDF",
    assignSalesManager: "Designar gerente de ventas",
    shareViaEmail: "Compartir vía correo electrónico",
    sendEmail: "ENVIAR CORREO ELECTRÓNICO",
    emailSend: "SE HA ENVIADO EL CORREO ELECTRÓNICO CORRECTAMENTE",
    donwload: "Descargar",
    deleteFile: "Eliminar archivo",
    invalidFileData:
      "Los datos de la clave de activación en el archivo no son válidos",
  },
}